module.exports = __webpack_public_path__ + "img/byq.195839d1.png";